import React, {Component} from 'react'
import {getShippedOn} from './get'

class ShippedOnLabel extends Component {

  constructor(props) {
    super(props)
    this.state = {
      shippedOn: null
    }
  }

  isInViewport = () => {
    let {shippedOn} = this.state
    let {orderId} = this.props

    //get how much pixels left to scrolling our ReactElement
    const element = document.getElementById('shipped-on-label-'+orderId)
    const {top} = element == null ? {} : element.getBoundingClientRect()
    //here we check if element top reference is on the top of viewport
    /*
    * If the value is positive then top of element is below the top of viewport
    * If the value is zero then top of element is on the top of viewport
    * If the value is negative then top of element is above the top of viewport
    * */
    if(top <= 1000 && shippedOn == null) {
      document.removeEventListener("scroll", this.isInViewport)
      this.getShippedOn()
        //console.log("Element is in view or above the viewport")
    } else {
        // console.log("Element is outside view");
    }
  }

  componentDidMount() {
    this.isInViewport()
    document.addEventListener("scroll", this.isInViewport)
    window.addEventListener('get-shipped-on-done', this.updateFromWindowDot)
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.isInViewport)
    window.removeEventListener('get-shipped-on-done', this.updateFromWindowDot)
  }

  getShippedOn = () => {
    let {orderId} = this.props
    if (window.shippedOn == null) return
    window.shippedOn[orderId] = '⏳' //loading
    this.updateFromWindowDot()

    clearTimeout(window.shippedOnSetTimeout)
    window.shippedOnSetTimeout = setTimeout(() => {
      getShippedOn((err, res) => {
        if (err) {
          alert('There was an error when trying to get shipped on date')
        } else {
          let {shippedOn} = res.data
          Object.keys(shippedOn).forEach(orderId => window.shippedOn[orderId] = shippedOn[orderId])
          //send out event to update from window to state
          window.dispatchEvent(new Event('get-shipped-on-done'))
        }
      })
    }, 1500)
  }

  updateFromWindowDot = () => {
    let {orderId} = this.props
    this.setState({shippedOn: window.shippedOn[orderId]})
  }

  render() {
    let {orderId} = this.props
    let {shippedOn} = this.state

    return (
      <span id={'shipped-on-label-'+orderId}>{shippedOn != null && shippedOn.length > 1 ? 'on ' : ''}{shippedOn}</span>
    )
  }

}

export default ShippedOnLabel
